




















































import { Component, Vue, Watch } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import { addPrizeDetails, queryPrizeDetailsById, updatePrizeDetails } from '@/api/prize.ts'
import { baseUrl } from '@/config.json'
import { getToken } from '@/utils/cookies'
import { encrypt, decrypt } from '@/utils/crypto'

@Component({
  name: 'addPromotionalImage',
  components: {
    HeadLable,
    ImageUpload
  }
})
export default class extends Vue {
  private restKey: number = 0
  private textarea: string = ''
  private value: string = ''
  private title = '新建奖品详情';
  private title1 = '';
  private imageUrl: string = ''
  private actionType: string = 'add'
  private vueRest = '1'
  private index = 0
  private type = 0
  private inputStyle = { flex: 1 }
  private titleId = ''
  private titleId1 = ''
  private headers = {
    token: getToken()
  }
  private ruleForm = {
    id: '',
    context: '',
    title: '',
    number: '',
  }

  get rules() {
    return {
      context: {
        required: true,
        message: '详情图片不能为空'
      },
      // title: {
      //   required: true,
      //   message: '奖品详情标题不能为空'
      // },
      number: {
        required: true,
        message: '奖品详情顺序不能为空'
      },
    }
  }

  created() {
    this.titleId1 = this.$route.query.titleId;
    this.title1 = this.$route.query.title;
    this.actionType = this.$route.query.id ? 'edit' : 'add';
    this.name()
    if (this.$route.query.id) {
      this.title = '修改奖品详情信息';
      this.init();
    }
  }

  private name() {
    try {
      // 解密
      this.titleId = decrypt(this.$route.query.titleId as string)
    } catch (e) {
      console.error("解密失败:", e)
      // this.title = "默认标题"
    }
  }

  private async init() {
    queryPrizeDetailsById(this.$route.query.id).then(res => {
      if (res && res.data && res.data.code === 1) {
        this.imageUrl = res.data.data.context
        this.ruleForm = res.data.data
      } else {
        this.$message.error(res.data.msg)
      }
    })
  }

  cancel() {
    this.$router.push({ path: '/competition/prizeDetailsManage', query: { titleId: this.titleId1, title: this.title1 } })
  }

  private submitForm(formName: any, st: any) {
    ;(this.$refs[formName] as any).validate((valid: any) => {
      console.log(valid, 'valid')
      if (valid) {
        if (!this.ruleForm.context) return this.$message.error('详情图片不能为空')
        // if (!this.ruleForm.title) return this.$message.error('奖品详情标题不能为空')
        if (!this.ruleForm.number) return this.$message.error('奖品详情顺序不能为空')
        let params: any = { ...this.ruleForm }
        // let params: any = {}
        // // params.flavors = this.dishFlavors
        // params.image = this.ruleForm.image
        // params.name = this.ruleForm.name
        params.type = 0
        // params.price *= 100
        if (this.actionType == 'add') {
          params.titleId = this.titleId
          delete params.id
          addPrizeDetails(params)
            .then(res => {
              if (res.data.code === 1) {
                this.$message.success('奖品详情新建成功！')
                  this.$router.push({ path: '/competition/prizeDetailsManage', query: { titleId: this.titleId1, title: this.title1 } })
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        } else {
          delete params.createTime
          delete params.updateTime
          params.id = this.ruleForm.id
          params.number = this.ruleForm.number
          updatePrizeDetails(params)
            .then(res => {
              if (res && res.data && res.data.code === 1) {
                this.$router.push({ path: '/competition/prizeDetailsManage', query: { titleId: this.titleId1, title: this.title1 } })
                this.$message.success('奖品详情信息修改成功！')
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
              // if (res.data.code == 200) {
              //   this.$router.push({'path': '/dish'})
              //   this.$message.success('菜品修改成功！')
              // } else {
              //   this.$message.error(res.data.desc || res.data.message)
              // }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        }
      } else {
        return false
      }
    })
  }

  imageChange(value: any) {
    this.ruleForm.context = value
  }
}
